import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LogoMark } from "@/components/app/Logo";
import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";

export default function Landing() {
  const { user } = useAuth();
  const target = user ? "/projects" : "/login";

  return (
    <div className="min-h-screen relative overflow-hidden">
      <div className="relative z-10 min-h-screen flex flex-col">
        {/* Top-right utility bar */}
        <div className="p-6 flex items-center justify-end">
          {user ? (
            <div className="text-[11px] font-mono uppercase tracking-[0.22em] text-foreground/70">
              Signed in as <b className="text-foreground">{user.email}</b>
            </div>
          ) : (
            <Link to="/login" className="text-xs font-mono uppercase tracking-[0.22em] text-foreground/70 hover:text-foreground">
              Sign in →
            </Link>
          )}
        </div>

        {/* Center hero */}
        <div className="flex-1 grid place-items-center px-6">
          <div className="text-center">
            <div className="flex items-center justify-center gap-6 flex-wrap landing-fade">
              <LogoMark size={112} className="landing-logo drop-shadow-[0_12px_40px_rgba(60,50,80,0.35)]" />
              <div className="text-left">
                <div className="font-heading text-sm sm:text-base font-bold tracking-[0.32em] text-foreground/80">
                  NAT HABITAT
                </div>
                <h1 className="font-heading text-4xl sm:text-5xl font-bold leading-tight mt-1">
                  Back Office
                </h1>
              </div>
            </div>

            <div className="mt-10 inline-flex items-center gap-2 rounded-full border border-white/40 bg-white/40 backdrop-blur-md px-4 py-2 landing-fade landing-fade-2">
              <Sparkles className="h-3.5 w-3.5 text-primary" />
              <span className="text-xs sm:text-sm font-mono uppercase tracking-[0.18em] text-foreground/80">
                Powered by its own in-house AI
              </span>
            </div>

            <div className="mt-10 flex items-center justify-center gap-3 landing-fade landing-fade-3">
              <Link to={target}>
                <Button
                  size="lg"
                  className="rounded-full px-8 py-6 text-base shadow-glossy group"
                  data-testid="landing-enter"
                >
                  Enter Back Office
                  <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-0.5 transition-transform" />
                </Button>
              </Link>
              {!user && (
                <Link to="/login" className="text-sm text-foreground/70 hover:text-foreground underline underline-offset-4">
                  Or sign in
                </Link>
              )}
            </div>
          </div>
        </div>

        <div className="p-6 text-center text-[10px] font-mono uppercase tracking-[0.28em] text-foreground/50">
          nathabitat.xyz · © {new Date().getFullYear()}
        </div>
      </div>
    </div>
  );
}
